/*
 * Filename: \src\Settings\Vendors\Common\CopyCode.js
 * Created Date: 2025-12-10 13:42
 * Author: jdkohl
 * 
 * Copyright (c) 2025 Logical Developments
 */


import { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCopy } from "@fortawesome/free-solid-svg-icons";
import { portalURL } from "#src/Configuration/Config";
import { companyName } from "#root/src/Configuration/Config.js";

const vendorPortalRegisterURL = `${portalURL}/vendor/register`

export default function CopyCodeCommon({ title, vendor }) {
  const [copiedURL, setCopiedURL] = useState(false);
  const [copiedCode, setCopiedCode] = useState(false);

  /**
   * Copy the provided text to the clipboard.
   * Use the stateSetter function to set the relevant state to true,
   *  reverting to false after two seconds.
   * @param {string} text 
   * @param {Function} stateSetter 
   */
  const handleCopyToClipboard = async (text, stateSetter) => {
    if (text) {
      try {
        await navigator.clipboard.writeText(text);
        stateSetter(true);
        setTimeout(() => stateSetter(false), 2000);
      } catch (err) {
        console.error("Failed to copy to clipboard:", err);
      }
    }
  };

  return (
    <div>
      {title && <h3 style={{marginBottom: "2ch"}}>{title}</h3>}
      <div className="stack y-auto">
        {vendor?.email
        ? <div>
          {vendor?.email} has been emailed a registration link for {companyName}'s vendor portal.
        </div>
        : <div className="">
          <p>Contact your vendor and ask them to register an account at:</p>
          <div className="inline-icon">
            <a href={vendorPortalRegisterURL}>{vendorPortalRegisterURL}</a>
            {copiedURL
              ? <span style={{color: "var(--clr-validation-valid-900)"}}>Copied to clipboard!</span>
              : <FontAwesomeIcon icon={faCopy} size={'lg'} onClick={() => { handleCopyToClipboard(vendorPortalRegisterURL, setCopiedURL)}} />
            }
          </div>
          <p>using the code shown below:</p>
          <div className="inline-icon">
            <p><strong>{vendor.code}</strong>
              {copiedCode
                ? <span style={{color: "var(--clr-validation-valid-900)"}}>Copied to clipboard!</span>
                : <FontAwesomeIcon icon={faCopy} size={'lg'} onClick={() => { handleCopyToClipboard(vendor?.code, setCopiedCode)}}/>
              }
            </p>
          </div>
        </div>}
      </div>
    </div>
  );
}